import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { file_path } from "./environment";

function Select({ guide }) {

    function onPublicationSelected(event) {
        const publication_id = event.target.value;
        window.location.href = `/feedback/${publication_id}`;
    }

    const options = guide.publications.sort((p1, p2) => parseInt(p2.id) - parseInt(p1.id)).map((pub) => {
        return <option value={pub.name} key={pub.name}>{pub.name}</option>
    });

    return (
        <select
            key={guide.id}
            id={guide.id}
            className="feedback-select"
            onChange={onPublicationSelected}
            defaultValue=""
        >
            <option value="" key="none">Select publication...</option>
            {options}
        </select>
    );
}

function Guides({ guides }) {
    const guideEntries = Object.entries(guides || {});
    const guideList = guideEntries.sort(([idA], [idB]) => parseInt(idA) - parseInt(idB)).map(([id, guide]) => {
        return (
            <article className="feedback-guide-card" key={id}>
                <p className="feedback-guide-kicker">Guide</p>
                <h3 className="feedback-guide-name">{guide.name}</h3>
                <p>Choose a publication period to open detailed feedback.</p>
                <Select guide={guide} />
            </article>
        );
    });

    return (
        <div className="feedback-guide-grid">{guideList}</div>
    );
}

export default function Feedback() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get(file_path('/feedback.json')).then((res) => {
            setGuides(res.data);
        });
    }, []);

    useEffect(() => {
        document.title = "Client Feedback";
    }, []);

    return (
        <div className="container feedback-page">
            <div className="body feedback-body">
                <p className="guides-return-row">
                    <Link className="guides-return-link" to="/guides">Return to Portal</Link>
                </p>
                <header className="feedback-hero">
                    <p className="feedback-eyebrow">Archive Navigator</p>
                    <h2>Client Feedback</h2>
                    <p>
                        Browse guide-level feedback archives and jump directly to the publication period you need.
                    </p>
                </header>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
